var BASWebServices;
(function (BASWebServices) {
    var MultiplePreviewModalController = (function () {
        function MultiplePreviewModalController($scope, $http, $sce, ngDialog) {
            this.$scope = $scope;
            this.$http = $http;
            this.$sce = $sce;
            this.ngDialog = ngDialog;
            $scope.mpmc = this;
            this.$scope.isSignalFile = false;
            this.$scope.isTxtFile = false;
            this.$scope.isAnnotFile = false;
            this.$scope.isImage = false;
        }
        MultiplePreviewModalController.prototype.open = function (link) {
            this.$scope.dataLink = link;
            if (this.$scope.dataLink.toLowerCase().lastIndexOf(".wav") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".nis") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".nist") != -1) {
                this.$scope.isSignalFile = true;
                this.$scope.isTxtFile = false;
                this.$scope.isAnnotFile = false;
                this.$scope.isImage = false;
                this.$scope.dataLinkForAudio = this.$sce.trustAsResourceUrl(this.$scope.dataLink);
                var signalFileURL = this.$scope.dataLink;
                var webappRepl = BASWebServices.WebappReplace.Factory();
                baseFileName = webappRepl(signalFileURL);
                this.$scope.linkToEmuWebApp = null;
                var protocol = "http";
                if (signalFileURL.lastIndexOf("https://") != -1) {
                    protocol = "https";
                }
                var linkToEmuWebApp = "";
                linkToEmuWebApp = protocol + "://";
                linkToEmuWebApp += BASWebServices.ConfigService.GET_URL_EMU_WEBAPP();
                linkToEmuWebApp += "?audioGetUrl=" + signalFileURL;
                this.$scope.linkToEmuWebApp = linkToEmuWebApp;
            }
            else if (this.$scope.dataLink.toLowerCase().lastIndexOf(".txt") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".par") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".bpf") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".csv") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".eaf") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".exb") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".mau-append") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".xml") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".tab") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".txt") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".srt") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".sub") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".tei") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".vtt") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".lex") != -1) {
                this.$scope.isTxtFile = true;
                this.$scope.isSignalFile = false;
                this.$scope.isAnnotFile = false;
                this.$scope.isImage = false;
                this.$http.get(link, {
                    _this: this
                })
                    .then(function (response) {
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    var content = response.data;
                    config._this.$scope.dataToDisplay = content;
                })
                    .catch(function (response) {
                    var data = response.data;
                    var headers = response.headers;
                    var config = response.config;
                    config._this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Service execution was unsuccessful!', "Data: " + data + " | Status: " + status);
                });
            }
            else if (this.$scope.dataLink.toLowerCase().lastIndexOf(".textgrid") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".emur") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf("_annot.json") != -1) {
                this.$scope.isAnnotFile = true;
                var isTextGrid = false;
                if (this.$scope.dataLink.toLowerCase().lastIndexOf(".textgrid") != -1) {
                    isTextGrid = true;
                }
                var isEmuRFile = false;
                if (this.$scope.dataLink.toLowerCase().lastIndexOf(".emur") != -1) {
                    isEmuRFile = true;
                }
                this.$scope.isTxtFile = false;
                this.$scope.isSignalFile = false;
                var baseFileName = "";
                if (isTextGrid || isEmuRFile) {
                    baseFileName = this.$scope.dataLink.substring(0, this.$scope.dataLink.lastIndexOf("."));
                }
                else {
                    baseFileName = this.$scope.dataLink.substring(0, this.$scope.dataLink.lastIndexOf("_"));
                }
                var webappRepl = BASWebServices.WebappReplace.Factory();
                baseFileName = webappRepl(baseFileName);
                this.$scope.linkToEmuWebApp = null;
                var url = BASWebServices.ConfigService.GET_GUESS_SIGNAL_FILE_FROM_ANNOTATION_FILE_URL();
                url += "?annotationFileLink=" + this.$scope.dataLink;
                this.$http.head(url, {
                    _this: this,
                    link: link
                })
                    .then(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    var protocol = "http";
                    if (baseFileName.lastIndexOf("https://") != -1) {
                        protocol = "https";
                    }
                    var linkToEmuWebApp = "";
                    linkToEmuWebApp = protocol + "://";
                    linkToEmuWebApp += BASWebServices.ConfigService.GET_URL_EMU_WEBAPP();
                    var signalFileURL = baseFileName + ".wav";
                    linkToEmuWebApp += "?audioGetUrl=" + signalFileURL;
                    linkToEmuWebApp += "&labelGetUrl=" + config._this.$scope.dataLink;
                    var labelType = "annotJSON";
                    if (isTextGrid) {
                        labelType = "TEXTGRID";
                    }
                    linkToEmuWebApp += "&labelType=" + labelType;
                    config._this.$http.head(signalFileURL, {
                        _this: config._this,
                        link: link
                    })
                        .then(function (response) {
                        console.log("We are here");
                        if (response.status == 200) {
                            config._this.$scope.linkToEmuWebApp = linkToEmuWebApp;
                        }
                        else {
                        }
                    })
                        .catch(function (response) {
                        config._this.$http.get(link, {
                            _this: config._this
                        })
                            .then(function (response) {
                            var config = response.config;
                            var content = response.data;
                            config._this.$scope.dataToDisplay = content;
                        });
                    });
                })
                    .catch(function (response) {
                });
            }
            else if (this.$scope.dataLink.toLowerCase().lastIndexOf(".png") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".gif") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".jpg") != -1
                || this.$scope.dataLink.toLowerCase().lastIndexOf(".jpeg") != -1) {
                this.$scope.isImage = true;
                this.$scope.isTxtFile = false;
                this.$scope.isSignalFile = false;
                this.$scope.isAnnotFile = false;
            }
            var _scope = this.$scope;
            this.ngDialog.open({
                template: 'views/partials/dialogs/MultiplePreviewModalTemplate.html',
                className: 'ngdialog-theme-default',
                scope: _scope
            });
        };
        MultiplePreviewModalController.prototype.setEMUWebAppPreviewLink = function (_this, isTextGrid, isEmuRFile, baseFileName) {
        };
        return MultiplePreviewModalController;
    }());
    BASWebServices.MultiplePreviewModalController = MultiplePreviewModalController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=MultiplePreviewModalController.js.map